import {DEFAULT_MAXIMUM_ASSIGNEES} from '@github-ui/item-picker-assignee'
import {useMemo} from 'react'

import {SystemColumnId} from '../../api/columns/contracts/memex-column'
import type {ColumnModel} from '../../models/column-model'

/**
 * Determine if the assignee limit has been reached.
 *
 * @param columnId - The ID of the column being edited
 * @param selectedCount - The number of currently selected items
 * @param maximumAssignees - The maximum number of assignees allowed
 * @returns true if the column is an assignees column and the limit has been reached or exceeded
 */
export function useAssigneeLimitReached(
  columnId: ColumnModel['id'],
  selectedCount: number,
  maximumAssignees: number = DEFAULT_MAXIMUM_ASSIGNEES,
): boolean {
  return useMemo(
    () => columnId === SystemColumnId.Assignees && selectedCount >= maximumAssignees,
    [columnId, selectedCount, maximumAssignees],
  )
}
